import { render } from "./ViewRevisions.vue?vue&type=template&id=e53050f6"
import script from "./ViewRevisions.vue?vue&type=script&lang=js"
export * from "./ViewRevisions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__